var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDolarss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9 4.45C1.765 4.155 1.4 3.85 1.4 3.375C1.4 2.83 1.905 2.45 2.75 2.45C3.46 2.45 3.815 2.72 3.945 3.15C4.005 3.35 4.17 3.5 4.38 3.5H4.53C4.86 3.5 5.095 3.175 4.98 2.865C4.77 2.275 4.28 1.785 3.5 1.595V1.25C3.5 0.835 3.165 0.5 2.75 0.5C2.335 0.5 2 0.835 2 1.25V1.58C1.03 1.79 0.25 2.42 0.25 3.385C0.25 4.54 1.205 5.115 2.6 5.45C3.85 5.75 4.1 6.19 4.1 6.655C4.1 7 3.855 7.55 2.75 7.55C1.925 7.55 1.5 7.255 1.335 6.835C1.26 6.64 1.09 6.5 0.885 6.5H0.745C0.41 6.5 0.175 6.84 0.3 7.15C0.585 7.845 1.25 8.255 2 8.415V8.75C2 9.165 2.335 9.5 2.75 9.5C3.165 9.5 3.5 9.165 3.5 8.75V8.425C4.475 8.24 5.25 7.675 5.25 6.65C5.25 5.23 4.035 4.745 2.9 4.45Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDolarss);
export default __webpack_public_path__ + "static/media/dolarss.62ba37fd2d9469e3106506d9e1d9bb42.svg";
export { ForwardRef as ReactComponent };